import { apiPost } from '@/api/client';

export type TelemetryEventPayload = {
  name: string;
  properties?: Record<string, unknown>;
  timestamp?: string;
  eventPage?: string;
};

/** POST a batch of UI telemetry events to the server sink. */
export function postAnalyticsEvents(events: TelemetryEventPayload[]): Promise<{ accepted: number }> {
  return apiPost<{ accepted: number }>('/analytics/events', { events });
}
